import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { REPORTS } from "helpers/viewContent";
//imported
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";
import PieChart from "./PieChart";
import PieChartCombine from "./PieChartCombine";
import Earning from "./Earning";
import Classification from "./Classification";

import { getWithoutPaginationList_ } from "store/services/commonService";
import WTNRanking from "./WTNRanking";
import CountryChart from "./CountryChart";
import CountryChartZipcode from "./CountryChartZipcode";
import Promocode from "./Promocode";
import AdminUserPost from "./AdminUserPost";
import WTNRange from "./WTNRange";

const Listing = ({ dispatch }) => {
  const [listing, setListing] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [selectedOtherInterval, setSelectedOtherInterval] = useState("monthly");
  const [otherlist, setOtherlist] = useState({});
  const [wtnRanking, setWtnRanking] = useState({});
  const [listingEarning, setlistingEarning] = useState({});
  const [countryList, setcountryList] = useState({});
  const [promocodeList, setPromocodeList] = useState({});
  const [postList, setPostList] = useState({});
  const [classificationData, setClassificationData] = useState({});
  const [ishowToggleCountry, setIsShowToggleCountry] = useState(false);
  const [ishowToggleZipCode, setIshowToggleZipCode] = useState(false);
  const [ishowToggleClassification, setIshowToggleClassification] =
    useState(false);
  const [ishowToggleWTN, setIshowToggleWTN] = useState(false);
  const [ishowToggleGender, setIshowToggleGender] = useState(false);
  const [ishowToggleEarning, setIshowToggleEarning] = useState(false);
  const [wtnList, setWtnList] = useState([]);
  const [wtnFields, setwtnFields] = useState({
    type: "1",
    wtn_range: "<10",
  });

  //other data
  const fetchDataOther = async (selectedOtherInterval) => {
    try {
      let query = {
        url: "report/other_list",
        earning_country: ishowToggleCountry ? "country" : "",
        earning_zipcode: ishowToggleZipCode ? "zip_code" : "",
        earning_classification: ishowToggleClassification
          ? "classification"
          : "",
        earning_wtn: ishowToggleWTN ? "wtn" : "",
        earning_gender: ishowToggleGender ? "gender" : "",
        earning: ishowToggleEarning ? "earning" : "",
        interval: selectedOtherInterval,
      };
      setIsLoading(true);
      dispatch(actions.persist_store({ loader: true }));
      let res = await dispatch(getWithoutPaginationList_(query));
      dispatch(actions.persist_store({ loader: false }));
      setOtherlist(res?.body?.gender);
      setlistingEarning(res?.body?.earning);
      setWtnRanking(res?.body?.wtn_ranking);
      setcountryList(res?.body?.country);
      setClassificationData(res?.body?.classification);
      setPromocodeList(res?.body?.promo_code_user);
      setPostList(res?.body?.post_data);
      setIsLoading(false);
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      setIsLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    fetchDataOther(selectedOtherInterval);
    fetchData(selectedOtherInterval);
  }, [
    selectedOtherInterval,
    ishowToggleCountry,
    ishowToggleZipCode,
    ishowToggleClassification,
    ishowToggleWTN,
    ishowToggleGender,
    ishowToggleEarning,
  ]);

  const fetchData = async (selectedInterval) => {
    try {
      let query = {
        url: "report/list",
        interval: selectedInterval,
      };
      setIsLoading(true);
      dispatch(actions.persist_store({ loader: true }));
      let res = await dispatch(getWithoutPaginationList_(query));
      dispatch(actions.persist_store({ loader: false }));
      setListing(res?.body);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  };

  const handleIntervalChange_ = (newInterval) => {
    setSelectedOtherInterval(newInterval);
  };
  const fetchWtnData = async (selectedOtherInterval) => {
    try {
      let query = {
        ...wtnFields,
        url: "report/wtn_list_api",
        interval: selectedOtherInterval,
      };
      setIsLoading(true);
      dispatch(actions.persist_store({ loader: true }));
      let res = await dispatch(getWithoutPaginationList_(query));
      dispatch(actions.persist_store({ loader: false }));
      setWtnList(res?.body);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  };
  useEffect(() => {
    fetchWtnData(selectedOtherInterval);
  }, [selectedOtherInterval, wtnFields]);

  return (
    <>
      <Helmet title={REPORTS.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-format-list-bulleted menu-icon"></i>
          </span>{" "}
          {REPORTS.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.report_list}>{REPORTS.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Detail
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="">
                <b>Filter By</b>
              </h4>
              <div className="row">
                <div className="col-md-12">
                  <div className="btn-group" role="group" aria-label="Interval">
                    <button
                      type="button"
                      className={`btn btn-outline-primary ${
                        selectedOtherInterval === "daily" && "active"
                      }`}
                      onClick={() => handleIntervalChange_("daily")}
                    >
                      Daily
                    </button>
                    <button
                      type="button"
                      className={`btn btn-outline-primary ${
                        selectedOtherInterval === "weekly" && "active"
                      }`}
                      onClick={() => handleIntervalChange_("weekly")}
                    >
                      Weekly
                    </button>
                    <button
                      type="button"
                      className={`btn btn-outline-primary ${
                        selectedOtherInterval === "monthly" && "active"
                      }`}
                      onClick={() => handleIntervalChange_("monthly")}
                    >
                      Monthly
                    </button>
                    <button
                      type="button"
                      className={`btn btn-outline-primary ${
                        selectedOtherInterval === "yearly" && "active"
                      }`}
                      onClick={() => handleIntervalChange_("yearly")}
                    >
                      Yearly
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CountryChart
        selectedOtherInterval={selectedOtherInterval}
        setSelectedOtherInterval={setSelectedOtherInterval}
        countryList={countryList}
        handleIntervalChange_={handleIntervalChange_}
        ishowToggleCountry={ishowToggleCountry}
        setIsShowToggleCountry={setIsShowToggleCountry}
      />

      <CountryChartZipcode
        selectedOtherInterval={selectedOtherInterval}
        setSelectedOtherInterval={setSelectedOtherInterval}
        countryList={countryList}
        handleIntervalChange_={handleIntervalChange_}
        ishowToggleZipCode={ishowToggleZipCode}
        setIshowToggleZipCode={setIshowToggleZipCode}
      />

      <Classification
        selectedOtherInterval={selectedOtherInterval}
        classificationData={classificationData}
        handleIntervalChange_={handleIntervalChange_}
        ishowToggleClassification={ishowToggleClassification}
        setIshowToggleClassification={setIshowToggleClassification}
      />

      <WTNRanking
        selectedOtherInterval={selectedOtherInterval}
        setSelectedOtherInterval={setSelectedOtherInterval}
        wtnRanking={wtnRanking}
        handleIntervalChange_={handleIntervalChange_}
        ishowToggleWTN={ishowToggleWTN}
        setIshowToggleWTN={setIshowToggleWTN}
      />

      <PieChartCombine
        selectedOtherInterval={selectedOtherInterval}
        setSelectedOtherInterval={setSelectedOtherInterval}
        otherlist={otherlist}
        handleIntervalChange_={handleIntervalChange_}
        ishowToggleGender={ishowToggleGender}
        setIshowToggleGender={setIshowToggleGender}
      />

      <PieChart
        selectedOtherInterval={selectedOtherInterval}
        setSelectedOtherInterval={setSelectedOtherInterval}
        responseData={listing}
        handleIntervalChange_={handleIntervalChange_}
      />

      <Earning
        selectedOtherInterval={selectedOtherInterval}
        setSelectedOtherInterval={setSelectedOtherInterval}
        listingEarning={listingEarning}
        handleIntervalChange_={handleIntervalChange_}
        ishowToggleEarning={ishowToggleEarning}
        setIshowToggleEarning={setIshowToggleEarning}
      />

      <Promocode
        selectedOtherInterval={selectedOtherInterval}
        setSelectedOtherInterval={setSelectedOtherInterval}
        promocodeList={promocodeList}
        handleIntervalChange_={handleIntervalChange_}
        ishowToggleEarning={ishowToggleEarning}
        setIshowToggleEarning={setIshowToggleEarning}
      />

      <AdminUserPost
        selectedOtherInterval={selectedOtherInterval}
        setSelectedOtherInterval={setSelectedOtherInterval}
        postList={postList}
        handleIntervalChange_={handleIntervalChange_}
      />

      <WTNRange
        selectedOtherInterval={selectedOtherInterval}
        setSelectedOtherInterval={setSelectedOtherInterval}
        wtnList={wtnList}
        handleIntervalChange_={handleIntervalChange_}
        setwtnFields={setwtnFields}
        wtnFields={wtnFields}
      />
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    loader: state.Common.loader,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Listing);
